module.exports = __webpack_public_path__ + "img/T5-D-xh_14.de3e79ed.png";